<template>
  <section class="company-list">
    <div class="company-list__toolbar" v-if="companies && !loading">
      <div class="company-list__summary">
        <span class="company-list__summary-value">{{ totalCompanies }}</span>
        <span class="company-list__summary-label">{{ summaryLabel }}</span>
      </div>
    </div>

    <div v-if="loading && !companies.length" class="company-list__loader company-list__loader--inline">
      <div class="company-list__spinner">
        <span class="company-list__spinner-ring"></span>
        <span class="company-list__spinner-core"></span>
      </div>
      <p class="company-list__loader-title">Cargando clientes</p>
      <p class="company-list__loader-copy">Preparando el directorio disponible.</p>
    </div>

    <div
      v-if="!loading || companies.length"
      class="company-list__grid"
      :class="{ 'company-list__grid--loading': loading && companies.length }"
    >
      <button
        v-if="hasWritePermission"
        class="company-list__card company-list__card--create"
        type="button"
        @click.prevent="showModalFunc()"
      >
        <span class="company-list__create-icon">+</span>
        <div class="company-list__create-body">
          <span class="company-list__create-label">Nuevo cliente</span>
          <span class="company-list__create-copy">Crear nueva ficha.</span>
        </div>
      </button>

      <router-link
        v-for="company in companies"
        :key="company.id"
        :class="['company-list__card', 'company-list__card--link', getCardToneClass(company)]"
        :to="{ name: 'CompanyShow', params: { id: company.id } }"
      >
        <article class="company-list__entry">
          <div class="company-list__entry-top">
            <div class="company-list__avatar">
              <i v-if="company.rut > 30000000" class="fa fa-building"></i>
              <i v-else class="fa fa-user"></i>
            </div>
          </div>

          <div class="company-list__body">
            <h3 class="company-list__name">{{ company.name }}</h3>
            <p class="help">{{ { SIN_REVISION: 'Sin revisión previa', PENDIENTE: 'Pendiente de revisión', APROBADA: 'Aprobada', CORRECCIONES: 'Correcciones solicitadas' }[company.review_status] }}</p>
            <p class="company-list__rut">{{ getFullRut(company.rut + company.dv) }}</p>
            <p :class="['company-list__status', getStatusToneClass(company.status)]">{{ company.status ? company.status : 'Activo' }}</p>

            <div v-if="company.data_quality" class="company-list__quality">
              <div class="company-list__quality-head">
                <span class="company-list__quality-label">Ficha completa</span>
                <strong :class="['company-list__quality-value', getQualityToneClass(company)]">
                  {{ company.data_quality.percentage }}%
                </strong>
              </div>
              <div class="company-list__quality-bar">
                <span
                  :class="['company-list__quality-fill', getQualityFillClass(company)]"
                  :style="{ width: `${company.data_quality.percentage}%` }"
                ></span>
              </div>
              <ul v-if="getVisibleMissingItems(company).length" class="company-list__quality-missing">
                <li v-for="item in getVisibleMissingItems(company)" :key="item">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>

          <div class="company-list__footer">
            <span class="company-list__footer-text">Ver ficha</span>
            <span class="company-list__footer-arrow">&rarr;</span>
          </div>
        </article>
      </router-link>
    </div>

    <div v-if="!loading && !companies.length" class="company-list__empty">
      <p class="company-list__empty-title">No hay clientes para mostrar.</p>
      <p class="company-list__empty-copy">Prueba otra búsqueda o crea un nuevo registro.</p>
    </div>

    <div v-if="loading && companies.length" class="company-list__loader company-list__loader--overlay">
      <div class="company-list__spinner company-list__spinner--compact">
        <span class="company-list__spinner-ring"></span>
        <span class="company-list__spinner-core"></span>
      </div>
      <p class="company-list__loader-title">Actualizando clientes</p>
    </div>

    <companyForm
      title="Nuevo Cliente"
      :visible="showFormModal"
      @close-modal-func="closeModalFunc"
      :formName="'companyForm'"
      @save="saveCompany"
      :saveLabel="'Crear'"
      :error="error"
      :strError="strError"
    />
  </section>
</template>
<script>
import companyForm from '@/components/modalForm.vue'
import { formatRut, isValidRut } from '@/utils/rut'
export default {
  components: {
    companyForm
  },
  data: () => ({
    showFormModal: false,
    strError: '',
    error: false
  }),
  props: {
    companies: Array,
    loading: Boolean,
    hasWritePermission: Boolean,
    totalCompanies: Number,
    hasActiveSearch: Boolean
  },
  computed: {
    summaryLabel () {
      return this.hasActiveSearch ? 'resultados encontrados' : 'clientes disponibles'
    }
  },
  methods: {
    getFullRut (personRut) {
      if (!personRut) return ''
      const body = personRut.toString().replace('-', '')
      const dv = body[body.length - 1]
      return formatRut(body.substr(0, body.length - 1), dv)
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    closeModalFunc () {
      this.showFormModal = false
    },
    showModalFunc () {
      this.showFormModal = true
    },
    async saveCompany (newCompany) {
      console.log(newCompany)
      if (isValidRut(newCompany.rut + '-' + newCompany.dv)) {
        this.$axios
          .post('company/create', { company: newCompany })
          .then(response => {
            const company = response.data.company
            newCompany = company
            this.$router.push({ name: 'CompanyShow', params: { id: newCompany.id } })
          })
          .catch(error => {
            this.error = true
            this.strError = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || 'No fue posible crear la ficha.'
          })
      } else {
        this.strError = '*El rut no es valido'
        this.error = true
      }
    },
    getStatusToneClass (status) {
      const toneMap = {
        Activo: 'company-list__status--active',
        Inactivo: 'company-list__status--inactive',
        'Esporádico': 'company-list__status--sporadic',
        'TTG (Trámite de término de Giro)': 'company-list__status--ttg'
      }
      return toneMap[status] || 'company-list__status--active'
    },
    getCardToneClass (company) {
      const toneMap = {
        Activo: 'company-list__card--active',
        Inactivo: 'company-list__card--inactive',
        'Esporádico': 'company-list__card--sporadic',
        'TTG (Trámite de término de Giro)': 'company-list__card--ttg'
      }
      return toneMap[company.status] || 'company-list__card--active'
    },
    getQualityToneClass (company) {
      const toneMap = {
        good: 'company-list__quality-value--good',
        warning: 'company-list__quality-value--warning',
        critical: 'company-list__quality-value--critical'
      }
      return toneMap[company.data_quality && company.data_quality.tone] || 'company-list__quality-value--neutral'
    },
    getQualityFillClass (company) {
      const toneMap = {
        good: 'company-list__quality-fill--good',
        warning: 'company-list__quality-fill--warning',
        critical: 'company-list__quality-fill--critical'
      }
      return toneMap[company.data_quality && company.data_quality.tone] || 'company-list__quality-fill--neutral'
    },
    getVisibleMissingItems (company) {
      if (!company.data_quality || !company.data_quality.missing) return []
      return company.data_quality.missing.slice(0, 2)
    }
  }
}
</script>
<style scoped>
.company-list {
  position: relative;
  padding-top: 0.25rem;
}

.company-list__toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.9rem;
}

.company-list__summary {
  min-width: 138px;
  padding: 0.8rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 18px;
  background: rgba(255, 252, 247, 0.7);
  box-shadow: 0 14px 34px rgba(43, 34, 24, 0.05);
  text-align: right;
}

.company-list__summary-value {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #1f1a15;
}

.company-list__summary-label {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.74rem;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  color: rgba(36, 31, 25, 0.5);
}

.company-list__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.company-list__grid--loading {
  opacity: 0.35;
  filter: saturate(0.75);
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.company-list__card {
  position: relative;
  min-height: 132px;
  padding: 0.9rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.46);
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(255, 252, 247, 0.82), rgba(246, 239, 229, 0.72));
  box-shadow: 0 16px 34px rgba(43, 34, 24, 0.07);
  backdrop-filter: blur(14px);
}

.company-list__card::before {
  content: '';
  position: absolute;
  inset: 0.75rem;
  border: 1px solid rgba(161, 136, 94, 0.13);
  border-radius: 16px;
  pointer-events: none;
}

.company-list__card--link {
  display: block;
  color: inherit;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.company-list__card--link:hover,
.company-list__card--link:focus {
  color: inherit;
  transform: translateY(-1px);
  box-shadow: 0 20px 44px rgba(43, 34, 24, 0.09);
}

.company-list__card--create {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  cursor: pointer;
  text-align: left;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.company-list__card--create:hover,
.company-list__card--create:focus {
  transform: translateY(-1px);
  box-shadow: 0 20px 44px rgba(43, 34, 24, 0.09);
}

.company-list__create-icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: linear-gradient(135deg, #24201b 0%, #4a3c2b 100%);
  color: #f5efe6;
  font-size: 1.5rem;
  line-height: 1;
}

.company-list__create-body {
  min-width: 0;
}

.company-list__create-label {
  display: block;
  font-size: 1.1rem;
  font-weight: 700;
  color: #201b16;
}

.company-list__create-copy {
  display: block;
  margin-top: 0.2rem;
  color: rgba(36, 31, 25, 0.65);
  line-height: 1.45;
}

.company-list__entry {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.company-list__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
  color: #3f3224;
  font-size: 1rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.company-list__body {
  margin-top: 0.8rem;
}

.company-list__name {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.25;
  color: #1f1a15;
}

.company-list__rut {
  margin: 0.3rem 0 0;
  color: rgba(36, 31, 25, 0.58);
  font-size: 0.88rem;
  letter-spacing: 0.03rem;
}

.company-list__quality {
  margin-top: 0.8rem;
  padding: 0.72rem 0.78rem;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.42);
}

.company-list__quality-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
}

.company-list__quality-label {
  color: rgba(36, 31, 25, 0.54);
  font-size: 0.68rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
}

.company-list__quality-value {
  font-size: 1rem;
}

.company-list__quality-value--good {
  color: #2f6a43;
}

.company-list__quality-value--warning {
  color: #8a6520;
}

.company-list__quality-value--critical {
  color: #8a3f3f;
}

.company-list__quality-value--neutral {
  color: #5a6574;
}

.company-list__quality-bar {
  height: 8px;
  margin-top: 0.55rem;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(92, 72, 48, 0.08);
}

.company-list__quality-fill {
  display: block;
  height: 100%;
  border-radius: inherit;
}

.company-list__quality-fill--good {
  background: linear-gradient(90deg, #2f6a43 0%, #4d8c61 100%);
}

.company-list__quality-fill--warning {
  background: linear-gradient(90deg, #9f6b1f 0%, #c08d3b 100%);
}

.company-list__quality-fill--critical {
  background: linear-gradient(90deg, #8a3f3f 0%, #b85f5f 100%);
}

.company-list__quality-fill--neutral {
  background: linear-gradient(90deg, #5a6574 0%, #7b8796 100%);
}

.company-list__quality-missing {
  margin: 0.6rem 0 0;
  padding-left: 1rem;
  color: #59483a;
  font-size: 0.78rem;
  line-height: 1.35;
}

.company-list__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 0.9rem;
  color: rgba(36, 31, 25, 0.66);
}

.company-list__footer-text {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
}

.company-list__footer-arrow {
  font-size: 0.95rem;
}

.company-list__empty {
  margin-top: 1rem;
  padding: 1.4rem;
  border: 1px solid rgba(255, 255, 255, 0.46);
  border-radius: 22px;
  background: rgba(255, 252, 247, 0.7);
  text-align: center;
}

.company-list__empty-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #201b16;
}

.company-list__empty-copy {
  margin: 0.45rem 0 0;
  color: rgba(36, 31, 25, 0.64);
}

.company-list__loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  text-align: center;
}

.company-list__loader--inline {
  min-height: 180px;
  margin: 1rem 0 1.25rem;
  padding: 1.25rem 1rem;
}

.company-list__loader--overlay {
  position: absolute;
  inset: 4.5rem 0 auto;
  z-index: 2;
}

.company-list__loader-title {
  margin: 0;
  color: #162033;
  font-size: 0.98rem;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.company-list__loader-copy {
  max-width: 20rem;
  margin: 0;
  color: rgba(36, 31, 25, 0.56);
  font-size: 0.88rem;
}

.company-list__spinner {
  position: relative;
  width: 56px;
  height: 56px;
}

.company-list__spinner--compact {
  width: 42px;
  height: 42px;
}

.company-list__spinner-ring,
.company-list__spinner-core {
  position: absolute;
  inset: 0;
  border-radius: 50%;
}

.company-list__spinner-ring {
  border: 1.5px solid rgba(36, 31, 25, 0.08);
  border-top-color: #33281d;
  border-right-color: rgba(74, 60, 43, 0.35);
  animation: company-list-spin 0.9s cubic-bezier(0.65, 0.05, 0.36, 1) infinite;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}

.company-list__spinner-core {
  inset: 10px;
  background: radial-gradient(circle at 30% 30%, #ffffff, #ece2d5);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

@keyframes company-list-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 960px) {
  .company-list__grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .company-list__toolbar {
    justify-content: flex-start;
  }

  .company-list__card {
    min-height: 120px;
    padding: 0.85rem;
    border-radius: 20px;
  }
}
.company-list__status {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin: 0.65rem 0 0;
  padding: 0.34rem 0.68rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06rem;
  text-transform: uppercase;
}

.company-list__card--create {
  background: linear-gradient(160deg, rgba(54, 42, 31, 0.98), rgba(95, 74, 55, 0.92));
  border-color: rgba(88, 69, 49, 0.34);
  box-shadow: 0 18px 36px rgba(48, 36, 25, 0.18);
}

.company-list__card--create::before {
  border-color: rgba(241, 228, 212, 0.18);
}

.company-list__card--create .company-list__create-label {
  color: #fbf5ee;
}

.company-list__card--create .company-list__create-copy {
  color: rgba(251, 245, 238, 0.72);
}

.company-list__card--create .company-list__create-icon {
  background: linear-gradient(135deg, rgba(252, 247, 239, 0.16), rgba(252, 247, 239, 0.32));
  border: 1px solid rgba(255, 244, 229, 0.18);
  color: #fff8f0;
}

.company-list__card--active {
  background: linear-gradient(180deg, rgba(242, 248, 243, 0.96), rgba(231, 241, 233, 0.9));
  border-color: rgba(110, 145, 118, 0.26);
}

.company-list__card--inactive {
  background: linear-gradient(180deg, rgba(243, 241, 239, 0.96), rgba(232, 229, 226, 0.9));
  border-color: rgba(126, 119, 112, 0.24);
}

.company-list__card--sporadic {
  background: linear-gradient(180deg, rgba(249, 244, 236, 0.96), rgba(243, 232, 217, 0.9));
  border-color: rgba(166, 133, 90, 0.24);
}

.company-list__card--ttg {
  background: linear-gradient(180deg, rgba(239, 243, 247, 0.96), rgba(228, 233, 241, 0.9));
  border-color: rgba(111, 124, 150, 0.24);
}

.company-list__card--active::before,
.company-list__card--inactive::before,
.company-list__card--sporadic::before,
.company-list__card--ttg::before {
  inset: 0.72rem;
  border-width: 1px;
}

.company-list__card--active::after,
.company-list__card--inactive::after,
.company-list__card--sporadic::after,
.company-list__card--ttg::after {
  content: '';
  position: absolute;
  left: 1rem;
  right: 1rem;
  top: 0.9rem;
  height: 3px;
  border-radius: 999px;
  opacity: 0.9;
}

.company-list__card--active::after {
  background: linear-gradient(90deg, #6f8f77, rgba(111, 143, 119, 0.2));
}

.company-list__card--inactive::after {
  background: linear-gradient(90deg, #8f837a, rgba(143, 131, 122, 0.2));
}

.company-list__card--sporadic::after {
  background: linear-gradient(90deg, #b28758, rgba(178, 135, 88, 0.22));
}

.company-list__card--ttg::after {
  background: linear-gradient(90deg, #7182a0, rgba(113, 130, 160, 0.22));
}

.company-list__status--active {
  background: rgba(96, 131, 104, 0.12);
  color: #47664e;
}

.company-list__status--inactive {
  background: rgba(126, 118, 112, 0.12);
  color: #6b625c;
}

.company-list__status--sporadic {
  background: rgba(167, 129, 84, 0.13);
  color: #8a673f;
}

.company-list__status--ttg {
  background: rgba(112, 126, 156, 0.13);
  color: #5c6a86;
}
</style>
